import { DISTRICT, DOMAIN, INDUSTRY, SCALE_INDUSTRY } from '@/param/method_param';
import { getStorage, saveStorage } from "@/utils/localStoreUtil";
import { reqDistrictList, reqDomainList, reqIndustryList, reqScaleIndustryList } from '@/api/dictAPI';

const pageOptions = {
  namespaced: true,
  state: {
    // 地区
    districtList: getStorage(DISTRICT) || [],
    // 行业
    industryList: getStorage(INDUSTRY) || [],
    scaleIndustryList: getStorage(SCALE_INDUSTRY) || [],
    // 技术领域
    domainList: getStorage(DOMAIN) || [],
  },
  mutations: {
    SET_DISTRICT(state, value) {
      state.districtList = value;
    },
    SET_INDUSTRY(state, value) {
      state.industryList = value;
    },
    SET_SCALE_INDUSTRY(state, value) {
      state.scaleIndustryList = value;
    },
    SET_DOMAIN(state, value) {
      state.domain = value;
    },
  },
  actions: {
    /* 获取地区列表数据 */
    async getDistrictList(context, _) {
      const resp = await reqDistrictList();
      if (resp.result) {
        saveStorage(DISTRICT, resp.data);
        context.commit("SET_DISTRICT", resp.data);
      }
    },
    /* 获取行业列表数据 */
    async getIndustryList(context, _) {
      const resp = await reqIndustryList();
      if (resp.result) {
        saveStorage(INDUSTRY, resp.data);
        context.commit("SET_INDUSTRY", resp.data);
      }
    },
    /* 获取行业列表数据 */
    async getScaleIndustryList(context, _) {
      const resp = await reqScaleIndustryList();
      if (resp.result) {
        saveStorage(SCALE_INDUSTRY, resp.data);
        context.commit("SET_SCALE_INDUSTRY", resp.data);
      }
    },
    /* 获取技术领域 */
    async getDomainList(context, _) {
      const resp = await reqDomainList();
      if (resp.result) {
        saveStorage(DOMAIN, resp.data);
        context.commit("SET_DOMAIN", resp.data);
      }
    },
  },
  getters: {}
}

export default pageOptions;
